//-----------------------------------------------------
// - modal
//-----------------------------------------------------
export var modal = function() {
	$(document).on('click', '.btn.movie', function(event) {
		$('.modal-bg--close').css({
			'opacity': '1',
			'z-index': '11'
		});
		$('.block__modal-movie').css({
			'transform': 'translate(-50%,-50%)',
			'z-index': '12'
		});
		$('.block__modal-movie').find('video').get(0).play();
	});
	// $(document).on('click', '[class^="modal-"][class*="--close"]', function(event) {
	// 	$('.block__modal').removeAttr('style');
	// 	$('[class^="modal-"][class*="--close"]').removeAttr('style');
	// 	$.cookie('modal', '1_days', { expires: 1 });
	// });
    //
	// $(document).on('click', '.block__modal [class^="block__color_box"]', function() {
	// 	open( $(this).parents('[class^="block__modal"]').find('a').attr('href'), "_blank" ) ;
	// });


	$(document).on('click', '[class^="modal-"][class*="--close"]', function(event) {
		$('.modal-bg--close').css({
			'opacity': '0',
			'z-index': '-11'
		});
		$('[class^="block__modal"]').css({
			'transform': 'translate(-50%,100vh)',
			'z-index': '-12'
		});

			$('.block__modal-movie').find('video').get(0).pause();
	});

	$(document).on('click', '.block__modal-cookie [class^="block__color_box"]', function() {
		open( $(this).parents('[class^="block__modal-cookie"]').find('a').attr('href'), "_blank" ) ;
	});

};
var modal_add = function() {


};